import React, { useState } from 'react';
import {
  Box, Paper, Typography, TextField, Button, Alert, CircularProgress,
  InputAdornment,
} from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { solicitarRecuperarPassword } from '../services/authApi';
import TurnstileWidget from '../components/TurnstileWidget';

export default function RecuperarPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError]     = useState('');
  const [tsToken, setTsToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Ingrese su correo electrónico');
      return;
    }
    if (!tsToken) {
      setError('Espere a que se complete la verificación de seguridad.');
      return;
    }
    setLoading(true);
    try {
      await solicitarRecuperarPassword(email.trim(), tsToken);
      setEnviado(true);
    } catch (err) {
      // El backend responde 200 incluso para emails no registrados.
      // Solo llegamos acá por errores reales de red o servidor.
      setError(err?.data?.mensaje || 'No se pudo procesar la solicitud. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight:'100vh',
      background:'linear-gradient(135deg,#0a1f12 0%,#1a4d2e 50%,#0a1f12 100%)',
      display:'flex', alignItems:'center', justifyContent:'center', p:2,
    }}>
      <Box sx={{ width:'100%', maxWidth:430 }}>
        <Paper elevation={24} sx={{ borderRadius:3, overflow:'hidden' }}>
          {/* Header */}
          <Box sx={{
            background:'linear-gradient(135deg,#1a4d2e 0%,#2e7d32 60%,#43a047 100%)',
            color:'#fff', textAlign:'center', py:3.5, px:3,
          }}>
            <Typography variant="h5" sx={{ fontWeight:700, letterSpacing:'0.02em' }}>
              Recuperar contraseña
            </Typography>
            <Typography variant="caption" sx={{ color:'rgba(255,255,255,0.85)', display:'block', mt:0.5 }}>
              FENAGRO APL · Alianza Solidaria
            </Typography>
          </Box>
          <Box sx={{ height:4, background:'linear-gradient(90deg,#c8a84b,#f0d070,#c8a84b)' }}/>

          {/* Body */}
          <Box component="form" onSubmit={handleSubmit} sx={{ px:4, py:3.5 }}>
            {!enviado ? (
              <>
                <Typography sx={{ color:'#555', fontSize:'0.95rem', mb:2.5, lineHeight:1.6 }}>
                  Ingresa el correo con el que te afiliaste. Te enviaremos un enlace para crear una nueva contraseña.
                </Typography>

                {error && <Alert severity="error" sx={{ mb:2 }}>{error}</Alert>}

                <TextField
                  fullWidth label="Correo electrónico" type="email" autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  disabled={loading}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><EmailOutlinedIcon sx={{ color:'#7d8a7d' }}/></InputAdornment>,
                  }}
                  sx={{ mb:2.5 }}
                />

                <Button
                  fullWidth type="submit" variant="contained" disabled={loading} size="large"
                  endIcon={loading && <CircularProgress size={18} color="inherit" />}
                  sx={{
                    py:1.4, borderRadius:2, fontWeight:700, letterSpacing:'0.05em',
                    background:'linear-gradient(135deg,#1a4d2e,#43a047)',
                    '&:hover':{ background:'linear-gradient(135deg,#0e2a18,#2e7d32)' },
                  }}>
                  {loading ? 'Enviando…' : 'Enviar enlace de recuperación'}
                </Button>

                <TurnstileWidget onToken={setTsToken} action="forgot-password" />
              </>
            ) : (
              <Box sx={{ textAlign:'center', py:2 }}>
                <Box sx={{
                  width:64, height:64, borderRadius:'50%',
                  background:'#e8f5e9', color:'#2e7d32',
                  display:'inline-flex', alignItems:'center', justifyContent:'center',
                  fontSize:36, fontWeight:700, mb:2,
                }}>
                  ✓
                </Box>
                <Typography sx={{ fontWeight:700, fontSize:'1.1rem', color:'#1a3a1a', mb:1 }}>
                  Revisa tu correo
                </Typography>
                <Typography sx={{ color:'#555', fontSize:'0.9rem', lineHeight:1.6, mb:2 }}>
                  Si <strong>{email}</strong> está registrado en nuestra plataforma, recibirás en breve un correo con instrucciones para restablecer tu contraseña.
                </Typography>
                <Alert severity="info" icon={false} sx={{ textAlign:'left', mb:2, fontSize:'0.82rem' }}>
                  <strong>El enlace expira en 1 hora.</strong> Si no llega en 5 minutos, revisa tu carpeta de spam o solicita uno nuevo.
                </Alert>
                <Button
                  variant="text" size="small"
                  onClick={() => { setEnviado(false); setEmail(''); }}
                  sx={{ color:'#2e7d32', textTransform:'none', fontSize:'0.85rem' }}
                >
                  Probar con otro correo
                </Button>
              </Box>
            )}

            <Box sx={{ textAlign:'center', mt:3 }}>
              <a href="/login"
                style={{ color:'#666', textDecoration:'none', fontSize:'0.85rem', display:'inline-flex', alignItems:'center', gap:4 }}>
                <ArrowBackIcon sx={{ fontSize:16 }}/> Volver a iniciar sesión
              </a>
            </Box>
          </Box>
        </Paper>

        <Typography variant="caption" sx={{ display:'block', textAlign:'center', color:'rgba(255,255,255,0.3)', mt:2 }}>
          FENAGRO APL · NIT 901026305-2
        </Typography>
      </Box>
    </Box>
  );
}
